module.exports = __webpack_public_path__ + "static/media/small.dfc72c06.png";